import { ChangeDetectionStrategy, Component, Input, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { SwiperOptions } from "swiper";
import { Resolutions } from "@resolutions";
import { getImageUrlStatic } from "../../../../utils/utilsFunctions";
import { BlockMargin } from '@service/article/article.service';
import { MarginService } from '../margin.service';
import { SwiperConfigService } from '@service/swiper-config.service';

interface SimpleCarouselInterface
{
  type: string,
  heading; string,
  blocks: Array<BlockInterface>
}

interface BlockInterface
{
  imageLink: string,
  heading: string,
  imageWidth: Array<number>,
  imageHeight: Array<number>
}


@Component({
    selector: 'app-simple-carousel',
    templateUrl: './simple-carousel.component.html',
    styleUrls: ['./simple-carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SimpleCarouselComponent implements OnInit
{
  @Input() section: SimpleCarouselInterface;
  @Input() margin: BlockMargin;

  getImageUrlStatic = getImageUrlStatic;

  public swiperOpt: SwiperOptions;
  //= {
  //direction: "horizontal",
  //a11y: { enabled: true },
  //centeredSlides: false,
  //grid: { fill: "row" },
  //observeParents: false,
  //slidesPerView: "auto",
  //freeMode: true,
  //speed: 800,
  //spaceBetween: 16,
  //navigation: false,
  //   breakpoints: {
  //     [Resolutions.resolutionDesktopMinus]: {
  //       spaceBetween: 32,
  //       slidesPerView: 4,
  //     },
  //   },
  // };

  constructor(public changeDet: ChangeDetectorRef, public marginService: MarginService, private swiperCo: SwiperConfigService)
  {
    this.swiperOpt = this.swiperCo.getConfig(
      [0, Resolutions.resolutionDesktopMinus],
      null,
      [16, 32],
      null,
      [1, 4]
    );
  }

  ngOnInit(): void
  {
  }

  @HostListener('window:resize', ['$event'])
  public onWindowResize($event): void
  {
    this.changeDet.detectChanges();

  }
}
